import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { Skeleton } from '@mui/material';

import './mobile-slide-banner-style.scss';

import Carousel from '@src/componentsNew/Carousel/Carousel';

import { UI_COMPONENT } from '@queries';
import { uiComponent, uiComponent_uicomponent_items } from '@src/queries/__generated__/uiComponent';

import { VisibilityDetector } from '@components/VisibilityDetector';
import { gaV4BannerExposed, gaV4ClickBanner } from '@utils';
import { goToUrl } from '@src/utils/urlCheck';
import { SKELETON_COLOR } from '@src/utils/constants';

interface IProps {
  uiComponentVariable: {
    name: string;
    desktopSize: string;
    mobileSize: string;
  };
}

const MobileSlideBanner = ({ uiComponentVariable }: IProps) => {
  const history = useHistory();
  const [bannerItems, setBannerItems] = useState<uiComponent_uicomponent_items[]>([]);

  const { data, loading } = useQuery<uiComponent>(UI_COMPONENT, {
    variables: uiComponentVariable,
    onCompleted: (data) => {
      const banners = data?.uicomponent?.items;

      if (banners?.length) {
        const activeBanners = banners.filter((banner) => banner?.isActive && banner?.link !== null);

        setBannerItems(activeBanners);
      }
    },
  });

  const onClickBannerImg = async (item: uiComponent_uicomponent_items) => {
    goToUrl(history, item?.link);

    await gaV4ClickBanner(item.name ?? '');
  };

  if (loading) {
    return (
      <Skeleton
        variant="rectangular"
        width="100%"
        style={{ backgroundColor: SKELETON_COLOR, height: 'unset', aspectRatio: '390/207' }}
      />
    );
  }

  return bannerItems.length ? (
    <div className="mobile-slider-banner-wrapper">
      <Carousel
        customSetting={{
          dots: true,
          infinite: true,
          arrows: false,
          centerMode: true,
          centerPadding: '0',
          autoplay: true,
          autoplaySpeed: 4000,
          speed: 2000,
          slidesToShow: 1,
          slidesToScroll: 1,
          className: 'custom-slider',
          dotsClass: 'custom-dots',
        }}
      >
        {bannerItems.map((item) => (
          <VisibilityDetector
            key={item.id}
            onVisible={async () => {
              await gaV4BannerExposed(item?.name ?? '');
            }}
          >
            <img
              className="mobile-banner-item-img"
              src={item.imageMobileUrl}
              alt={item?.name ?? ''}
              onClick={() => onClickBannerImg(item)}
            />
          </VisibilityDetector>
        ))}
      </Carousel>
    </div>
  ) : null;
};

export default MobileSlideBanner;
